import { styled } from '@mui/material/styles';

const VoucherCard = styled('div')(({ theme }) => ({
  background: '#ecebeb',
  borderRadius: 5,
  border: '1px dashed #e0e0e0',
  padding: theme.spacing(2, 3),
  minWidth: '200px',
  minHeight: '140px',
  boxSizing: 'border-box',
  textAlign: 'center',
  '&:after, &:before': {
    content: '""',
    display: 'block',
    width: '24px',
    height: '24px',
    position: 'absolute',
    left: '-12px',
    background: '#fff',
    zIndex: '2',
    top: '50%',
    marginTop: '-12px',
    borderRadius: '50%',
  },
  '&:after': {
    right: '-12px',
    left: 'inherit',
  },
}));

export default VoucherCard;
